import { css } from '@emotion/react';

export const dividerStyles = css`
  width: 100%;
  height: 1px;
  border: 0;
  background-color: var(--border-primary);
`;
